import React from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';

import Text from '../Text';

import quotes from '../../../../static/images/quotes.svg';

const Quote = ({ styles, rules, message, color }) => {
    const intl = useIntl();
    const { formatMessage } = intl;
    const quotesMessage = formatMessage({ id: 'imageAlts.quotesIcon' });
    const contentMessage = formatMessage({ id: message });

    return (
        <div className={styles.container}>
            <img alt={quotesMessage} src={quotes} className={styles.quotes} />
            <Text color={color} extend={{ text: rules.extendText }}>
                {contentMessage}
            </Text>
        </div>
    );
};

Quote.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
        quotes: PropTypes.string.isRequired,
    }).isRequired,
    rules: PropTypes.shape().isRequired,
    message: PropTypes.string.isRequired,
    color: PropTypes.string,
};

Quote.defaultProps = {
    color: '#000',
};

export default Quote;
